<template>
    <div style="min-height:300px" v-if="data.length<1 && !is_fetching" class="mt-5 mb-5 font-weight-light text-center d-flex align-center ">
        <div class="ma-auto">
            <v-icon size="x-large">mdi-emoticon-confused-outline</v-icon>
            <h2>No results found.</h2>
            <p>Try changing your filters to explore more products.</p>
        </div>
    </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

defineProps<{
  data: any[]
}>()

const store = useGlobalsStore()
const { is_fetching } = storeToRefs(store)
</script>
